import {
	Component,
	Input,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { GenButtonGroupComponent } from "@app/gen-inputs/gen-button-group/gen-button-group.component"
import { GenSelectComponent } from "@app/gen-inputs/gen-select/gen-select.component"
import { Modalable } from "@app/Modalable"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { BtnExtComponent, CancelBtnComponent } from "@app/utils/utils.component"

@Component({
	selector: "app-bkmvdata-report",
	imports: [
		COMMON_IMPORTS,
		GenSelectComponent,
		GenButtonGroupComponent,
		BtnExtComponent,
		LangValPipe,
		CancelBtnComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./bkmvdata-report.component.html",
})
export class BkmvdataReportComponent extends Modalable {
	years: any[] = [] //the options for years to choose from
	data: any = null //will hold the data returning from the api call
	thisYear = new Date().getFullYear()
	lastYear = new Date().getFullYear() - 1
	year: number = this.thisYear
	mode: "ini" | "bkmvdata" = "ini"
	btns: any = { ini: false, bkmvdata: true }
	isDownloading: boolean = false
	identifier = 0

	totals: any = {}
	periodInputs: any[] = [
		{ value: this.thisYear, name: "this_year" },
		{ value: this.lastYear, name: "last_year" },
	]

	ngOnInit() {
		//reset values before opening the modal
		for (let i = 2018; i <= this.thisYear; i++) {
			this.years.push({ id: i, name: i })
		}
		this.identifier = 56565775
	}

	changeByPeriod() {
		//clicked the change period btn, change the year and runBkmv
		this.runBkmv()
	}

	async runBkmv() {
		//when called to open call runBkmv from the api
		this.loadData()
		//return;
		this.isDownloading = true
		this.downloadFile("ini")
		await this.store.timeout(3000)
		this.downloadFile("bkmvdata")
		this.loadData()
		this.isDownloading = false
	}

	async downloadFile(mode: "ini" | "bkmvdata") {
		//download the report for the chosn year (xlsx format)

		await this.store.downloadToastFunc(async () => {
			const res: any = await this.apiService.download("get_bkmvdata", {
				year: this.year,
				mode,
				identifier: this.identifier,
			})
			if (!res?.size) {
				return this.store.downloadFailedModal()
			}
			this.apiService.downloadFile(res, mode + ".txt")
		})
	}

	async loadData() {
		//download the report for the chosn year (xlsx format)

		const res: any = await this.apiService.post("get_bkmvdata", {
			year: this.year,
			mode: "bkmvdata",
			show_on_screen: "yes",
		})
		this.data = res
	}

	async print() {
		//print this report by creating a new document, opening it, and requesting the winodw to print

		let html = document.getElementById("section-to-print")?.innerHTML || "" //get the inner area to be replicated in the new document
		html = this.store.processHtmlPreDl(html) //remove noise in html tags (angular attributes etc)

		this.store.printWindow(`
		<html>
		<style type='text/css'>${this.store.getPrintStyle2()}</style>
		<body onload="window.print()" style="direction:rtl">
		${html}
		</body>
		</html>`)
	}
}
